import Backbone from 'backbone'
import template from './tooltips-banners-test.hbs'
import Tooltip from 'scoreboard/components/tooltip'
import $ from 'jquery'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import nonAbbreviatedValuesTooltip from 'scoreboard/scorecards/non-abbreviated-values-tooltip.hbs'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import testMultipleChoiceOptionTemplate from './test-multiple-choice-option-template.hbs'
import _ from 'lodash'
import plotTypes from 'scoreboard/charts/edit/serie/plot-types'

var TestCalendarsView = Backbone.View.extend({

	className: 'admin table-hack display-layout admin-test-view admin-test-tooltips-banners',

	MultiChoiceExample: BootslideMenu.MultipleChoiceOption.extend({
		property: 'someProperty',
		value: true,
		initialize: function (opt) {
			BootslideMenu.MultipleChoiceOption.prototype.initialize.apply(this, arguments)

			this.label = $(testMultipleChoiceOptionTemplate({
				icon: opt.icon,
				label: opt.label
			}))[0]
		},

		// There's nothing meaningful going on here, just flipping the someProperty property of the
		// fake model so that the checkmark can toggle in the bootslide menu
		updateModel() {
			let old = this.model.get('someProperty')
			this.model.set('someProperty', !old)
			this.model.trigger(`change:someProperty`, !old)
		}
	}),

	render: function () {
		this.$el.empty().append(template())

		this.$('.tooltip-button:not(.tooltip-details)').click(e => {
			let el = this.$(e.target)
			let showingTooltip = !el.data('showing-tooltip')
			el.data('showing-tooltip', showingTooltip)

			if (showingTooltip) {
				let extraClass = el.hasClass('error') ? 'has-error' : ''
				extraClass += ' test-tooltip'
				this.tooltip = new Tooltip({
					attachTo: el,
					content: `
					<div class="title">Tooltip Title</div>
					This is the tooltip content. It can contain <span>highlighted</span> words.
					`,
					placement: 'above',
					arrow: 'center',
					extraClass
				}).render()
			} else {
				this.tooltip && this.tooltip.remove()
			}
		})

		process.nextTick(() => {
			new TooltipAndDetails({
				el: this.el,
				selector: '[data-unshortened-value]',
				tooltipOptions: {
					extraClass: 'tooltip-and-details non-abbreviated-tooltip scorecards-overview-values-non-abbreviated-tooltip equation-viewer '
				},
				tooltipContent: e => {
					return nonAbbreviatedValuesTooltip({
						header: 'April 2016',
						value: '$450.550,000',
						equation: 'M(2778) + M(2778) + M(2778) + M(2778) + M(2778) + M(2778) + M(2778)',
						equationHeader: 'Equation Header',
						showDetailsLink: true
					})
				},
				details: e => {
					return 'DETAILS'
				},
				clickable: true
			})
		})

		let rowMenu = this.getMenuByType('row')
		let tileMenu = this.getMenuByType('tile')
		let checkmark = this.getMenuByType('checkmark')
		const TestBootslideMenu = BootslideMenu.extend({
			allowDynamicWidth: true,
			menu() {
				return {
					label: 'Test Bootslide Menu',
					target: [rowMenu, tileMenu, checkmark]
				}
			}
		})
		const TestBootslideMenuTiled = BootslideMenu.extend({
			menu() {
				return {
					label: 'Test Bootslide Menu Tiled',
					categories: [{
						key: 'Test Bootslide Menu',
						label: 'Test Bootslide Menu',
						target: [tileMenu, rowMenu, tileMenu, rowMenu, tileMenu]
					},{
						key: 'Test Bootslide Menu',
						label: 'Test Bootslide Menu',
						target: [tileMenu, rowMenu, tileMenu, rowMenu, tileMenu]
					},{
						key: 'Test Bootslide Menu',
						label: 'Test Bootslide Menu',
						target: [tileMenu, rowMenu, tileMenu, rowMenu, tileMenu]
					},{
						key: 'Test Bootslide Menu',
						label: 'Test Bootslide Menu',
						target: [tileMenu, rowMenu, tileMenu, rowMenu, tileMenu]
					}],
					layout: 'tiles'
				}
			}
		})

		let createBootslideTooltip = (button, bootslide) => {
			button.on('click', e => {
				this.bootslideTooltip = new Tooltip({
					attachTo: $(e.target),
					content: new bootslide({
						addButton: button
					}),
					placement: 'below',
					arrow: 'center',
					extraClass: 'has-bootslide-menu'
				}).render()
			})
		}

		createBootslideTooltip(this.$('.bootslide-normal'), TestBootslideMenu)
		createBootslideTooltip(this.$('.bootslide-tiled'), TestBootslideMenuTiled)

		return this
	},

	getMenuByType(type) {
		let checkmark = {
			label: 'I got checkmarks',
			target: _.map(plotTypes(), plotType => {
				let FakeModel = Backbone.Model.extend({
					someProperty: false
				})

				return {
					label: `Multiple Choice Option - ${plotType.type}`,
					contentView: new this.MultiChoiceExample({
						icon: plotType.type,
						label: `label - ${plotType.type}`,
						model: new FakeModel()
					})
				}
			})
		}

		let tile = {
			label: 'I got tiles',
			layout: 'tiles',
			target: [{
				key: 'dashboards.add.newChart',
				label: 'Tile 1',
				content: () => 'I am a tile',
				target: () => alert('tile 1')
			},{
				key: 'dashboards.add.newChart',
				label: 'Tile 2',
				content: () => 'I am a tile',
				target: () => alert('tile 2')
			},{
				key: 'dashboards.add.newChart',
				label: 'Tile 3',
				content: () => 'I am a tile',
				target: () => alert('tile 3')
			}]
		}

		let row = {
			label: 'Row Layout Menu',
			target: [{
				label: 'Row 1',
				target: () => alert('row 1')
			},{
				label: 'Row 2',
				target: () => alert('row 2')
			},{
				label: 'Row 3',
				target: () => alert('row 3')
			}]
		}

		switch (type) {
			case 'checkmark':
				return checkmark
			case 'tile':
				return tile
			case 'row':
				return row
		}
	}
})

export default TestCalendarsView
